import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/design-suite.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class DesignSuite extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Design Suite & Enterprise UX Engineering Heritage | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Design Suite, Designer Suite, Suite Design, Web Design Suite, Raster Graphics, Vector Graphics, Logo design, Brochure Design, Newsletter design, web page design, website design software, UI design, UX design, product design, enterprise interface design, software design, workflow design, information architecture, usability, design systems, digital experience, enterprise software engineering, legacy modernization"
          />
          <meta
            name="description"
            content="Design Suite preserves Avani Cimcon's UI, web, product design, and workflow design heritage. That experience now supports enterprise software modernization, information architecture, usability, and AI-enabled applications."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/design-suite" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Design Suite</h1>
            <h5>Enterprise UX and product design heritage</h5>
          </div>
          <div
            className="page-banner-img"
            style={{ backgroundImage: `url("${BannerImg}")` }}
          ></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify" style={{ minHeight: "300px" }}>
              <p className="font-weight-bold text-primary">
                Avani Cimcon's design heritage includes HTML, XHTML, tableless HTML, div-based
                HTML, CSS, style guides, Photoshop, Dreamweaver, Flash, and Action Script. That
                depth also reflects workflow design, information architecture, and usability
                thinking that still matter when enterprise software must feel clear, efficient, and
                trustworthy.
              </p>
              <p>
                The Design Suite experience matters because it reflects how engineering, visual
                design, and product thinking work together. It is evidence that the team can shape
                software that is usable, maintainable, and aligned with enterprise delivery
                requirements. That same experience now informs modern AI interfaces, operator
                workflows, and product experiences that need to be intuitive from the first click.
              </p>
              <p>
                In enterprise environments, design is not decoration. It reduces friction in
                workflows, clarifies information, and helps complex software feel approachable. That
                is why this page belongs in the engineering heritage section as much as in the
                visual design archive.
              </p>
              <h5 className="text-primary mt-4 mb-3">Why this design heritage still matters</h5>
              <ul>
                <li className="mb-2">
                  <Link to="/it-consulting-services">Clarify modernization programs through better enterprise consulting</Link>
                </li>
                <li className="mb-2">
                  <Link to="/value-proposition">Support the value proposition with usable, trustworthy systems</Link>
                </li>
                <li className="mb-2">
                  <Link to="/dxchange">Inform product interfaces and platform usability</Link>
                </li>
                <li>
                  <Link to="/contact-us">Discuss enterprise UX, IA, or AI interface design support</Link>
                </li>
              </ul>

              <p>
                Feel free to contact us anytime at{" "}
                <a href="mailto:inquiry@avanicimcon.com">
                  inquiry@avanicimcon.com
                </a>{" "}
                with your contact details, project scope and budget for further assistance. Thanks
                for visiting Avani Cimcon Technologies.
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DesignSuite;
